export class ReceiptsEventType {

	static UPDATE = 'UPDATE_RECEIPTS';

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/receipts/receipts.event.type.ts